import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(

    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Register the service worker
serviceWorkerRegistration.register();
